module.exports = __webpack_public_path__ + "img/filter-intensity-low--active.c4bf29ab.svg";